module.exports = __webpack_public_path__ + "81567d6c5b5b4752d54bfce5926fa67c.svg";